import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../api/client';

const FarmProfileContext = createContext();

export const useFarmProfile = () => useContext(FarmProfileContext);

export const FarmProfileProvider = ({ children }) => {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [logoBase64, setLogoBase64] = useState(null);

    const fetchProfile = async () => {
        try {
            const res = await api.get(`/api/farm-profile`);
            if (res.data?.id) {
                const profileData = res.data;

                // ✅ Fetch base64 logo and embed it
                if (profileData.logo_url) {
                    const logoRes = await api.get(`/api/logo-base64?logo_url=${encodeURIComponent(profileData.logo_url)}`);

                    profileData.logo_base64 = logoRes.data.base64; // Add base64 logo to profile
                }

                setProfile(profileData);
            }
        } catch (err) {
            console.error('Failed to load farm profile', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProfile();
    }, []);

    const updateProfile = (newProfile) => {
        setProfile(newProfile);
    };

    return (
        <FarmProfileContext.Provider value={{ profile, loading, logoBase64, updateProfile, fetchProfile }}>
            {children}
        </FarmProfileContext.Provider>
    );
};
